import { connect } from 'react-redux'
import { getShipmentNoteTags } from 'utils/actions/shipmentNoteTags'
import { openDialog } from 'utils/actions/ui'
import { handleSidebar } from '../../utils/actions/sidebar'
import { LoadDetailsCard } from './LoadDetailsCard'
import { NotesCard } from './NotesCard'
import { ReservedOfferDetails } from './ReservedOfferDetails'
import { ShipmentTrackerComponent } from './ShipmentTracker'
import { Sidebar } from './Sidebar'
import { TrackingDetails } from './TrackingDetails'

export { Reloads } from './Reloads'

export const SidebarTrackingDetails = connect(
  state => {
    const {
      mapbox,
      sidebar: {
        data: { shipment },
      },
    } = state
    return { shipment, mapbox }
  },
  dispatch => ({
    openBookingDialog: id => dispatch(openDialog(id)),
  })
)(TrackingDetails)

export const SidebarNotes = connect(
  state => {
    const {
      sidebar: { data: { shipment = {} } = {} },
    } = state
    return { shipmentId: shipment ? shipment.id : '' }
  },
  dispatch => ({
    getNoteTags: shipmentId => dispatch(getShipmentNoteTags(shipmentId)),
  })
)(NotesCard)

export const SidebarLoadDetails = connect(
  state => {
    const {
      sidebar: {
        data: { shipment },
      },
    } = state
    const { info: { carrierSpecialInstructions } = {}, stops = [], shipperInsuranceRequirement } =
      shipment || {}
    return {
      stops,
      carrierSpecialInstructions,
      shipperInsuranceRequirement,
    }
  },
  dispatch => ({
    closeSidebar: () => dispatch(handleSidebar()),
  })
)(LoadDetailsCard)

export const SidebarReservedOfferDetails = connect(state => {
  const {
    reservedOffer: {
      reservedOfferDetails: details,
      reservedOfferDetailsAreLoading: loading,
      reservedOfferDetailsError: error,
    },
    sidebar: {
      data: { shipment },
    },
  } = state

  return { loading, details, error, shipment }
})(ReservedOfferDetails)

export const ShipmentTracker = connect(state => {
  const {
    sidebar: {
      data: { shipment },
    },
  } = state

  return {
    shipment,
  }
})(ShipmentTrackerComponent)

export default Sidebar
